import { MitarbeiterErstellt } from '@/domain/mitarbeiter/features/anlageassistent/content/Success/MitarbeiterErstellt';
import { NextSteps } from '@/domain/mitarbeiter/features/anlageassistent/content/Success/NextSteps';

export function AnlageassistentSuccessPage() {
  return (
    <div className="flex flex-col gap-8 w-screen h-dvh items-center  py-20 px-8">
      <MitarbeiterErstellt />
      <NextSteps />
    </div>
  );
}
